import { SHTableHead, SHTableRow } from "@components/design-systems";
import { FeatureAnalysisRowDTO } from "@models/platform-analysis/entities/steps/feature";
import { flexRender, HeaderGroup } from "@tanstack/react-table";
import { Fragment, memo } from "react";

type AnalysisTableHeaderProps = {
  tableHeaderGroups: HeaderGroup<FeatureAnalysisRowDTO>[];
};

export const AnalysisTableHeader = memo(
  ({ tableHeaderGroups = [] }: AnalysisTableHeaderProps) => {
    return (
      <SHTableHead
        sx={{
          display: "grid",
          position: "sticky",
          top: 0,
          zIndex: 1,
        }}
      >
        {tableHeaderGroups?.map((headerGroup, headerIndex) => (
          <SHTableRow
            key={headerIndex}
            sx={{ border: "none", backgroundColor: "transparent !important" }}
          >
            {headerGroup.headers?.map((header, index) => (
              <Fragment key={index}>
                {flexRender(
                  header.column.columnDef.header,
                  header.getContext(),
                )}
              </Fragment>
            ))}
          </SHTableRow>
        ))}
      </SHTableHead>
    );
  },
);
